import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './InputControl.module.css';

export interface IInputControlProps {
    children: ReactNode;
    className?: string;
    hasErrors?: boolean;
    indented?: boolean;
    inline?: boolean;
    isFormControl?: boolean;
    readOnly?: boolean;
}
export function InputControl(props: IInputControlProps) {
    const className = classnames(styles.control, props.className || '', {
        [styles.isIndented]: props.indented,
        [styles.isReadonly]: props.readOnly,
        [styles.isInline]: props.inline,
        [styles.isFormcontrol]: props.isFormControl,
        'has-danger': props.hasErrors,
    });

    return <div className={className}>{props.children}</div>;
}
